export default __webpack_public_path__ + "static/las-df225b6c0c2f40fd2083ed5d28cade94.png";